import React from "react";
import GenericUploadForm from "src/components/FormFactory/GenericUploadForm";
import messages from "./messages"; // if you have local messages (optional)

const UploadEventsForm = (props) => {
  const {
    isUploadPending,
    uploadEventFiles,
    hideModal,
    intl,
  } = props;
  const handleSubmit = (formValues) => {
    uploadEventFiles(formValues);
  };

  return (
    <GenericUploadForm
      formName="uploadEventsForm"
      onSubmit={handleSubmit}
      hideModal={hideModal}
      intl={intl}
      isUploadPending={isUploadPending}
      uploadLabel={intl.formatMessage(messages?.uploadEventFiles)}
      fileFieldName="upload" // optional, default is "upload"
    />
  );
};

export default UploadEventsForm;
